export default __webpack_public_path__ + "static/gba_ep2_compressed-c8343ce9b683ccbb81aeb47b2f4c4547.mp4";